<div class="gbr-person-input-wrapper">
  <coin-v2-card
    styleVariant="large"
    padding="none"
    [class.edit]="edit">
    <div class="empty-profile">
      <img src="/assets/images/gbr/add-profile-2.png" />
      @if (!edit) {
        <p class="text">
          {{ (isChildInput ? 'gbr.person-input.child-info' : 'gbr.person-input.adult-info') | translate }}
        </p>
      } @else {
        <p>{{ 'gbr.person-input.fill-info' | translate }}</p>
      }

      <div style="flex: 1"></div>
      <div class="action-buttons">
        @if (!edit) {
          <coin-v2-button
            [type]="'primary'"
            [icon]="'add'"
            [iconPos]="'right'"
            [text]="'gbr.add' | translate"
            [disabled]="disabled"
            (click)="toggleEdit()"></coin-v2-button>
        } @else {
          <coin-v2-button
            [type]="'primary'"
            [icon]="'save'"
            [iconPos]="'right'"
            [text]="'gbr.save' | translate"
            [disabled]="!canSave"
            (click)="save()"></coin-v2-button>
          <coin-icon-button
            type="secondary"
            icon="close"
            (click)="toggleEdit()"></coin-icon-button>
        }
      </div>
    </div>

    @if (value || display) {
      <div
        animate.enter="fly-in-from-bottom"
        class="selected-person">
        <coin-siemens-energy-person-view
          [value]="value"
          [display]="display"
          [type]="type"
          [disabled]="disabled"
          (edit)="edit ? save() : toggleEdit()"
          (remove)="removeClick()"></coin-siemens-energy-person-view>
      </div>
    }

    @if (!display) {
      <div class="edit-profile">
        @if (!isChildInput) {
          <div class="multiple-inputs">
            <coin-v2-text-input
              icon="edit"
              matFormFieldClass="shadow"
              [placeholder]="'gbr.entry' | translate"
              [label]="'gbr.person-input.firstname' | translate"
              [(ngModel)]="$any(formPerson).firstname" />
            <coin-v2-text-input
              icon="edit"
              matFormFieldClass="shadow"
              [placeholder]="'gbr.entry' | translate"
              [label]="'gbr.person-input.lastname' | translate"
              [(ngModel)]="$any(formPerson).lastname" />
          </div>
          <coin-siemens-energy-location-input [data]="$any(formPerson).location"></coin-siemens-energy-location-input>
          <div class="gid-input">
            <coin-v2-text-input
              icon="search"
              matFormFieldClass="shadow"
              [placeholder]="'gbr.entry' | translate"
              [label]="'gbr.person-input.gid' | translate"
              [(ngModel)]="$any(formPerson).gidOrEmail" />
          </div>
        } @else {
          <div class="multiple-inputs">
            <mat-form-field
              class="coin-form-field-outline coin-form-field-outline--shadow coin-form-field-outline--date"
              appearance="outline"
              floatLabel="always"
              (click)="rangePicker.open()">
              <mat-label>{{ 'gbr.person-input.birthday' | translate }}</mat-label>
              <input
                matInput
                readonly
                [max]="today"
                [matDatepicker]="rangePicker"
                [placeholder]="'gbr.entry' | translate"
                [(ngModel)]="$any(formPerson).birthday" />
              <mat-icon matSuffix>date_range</mat-icon>
              <mat-datepicker #rangePicker></mat-datepicker>
            </mat-form-field>

            <coin-v2-dropdown
              required
              matFormFieldClass="shadow"
              [label]="'gbr.person-input.same-household' | translate"
              [(ngModel)]="$any(formPerson).sameHousehold">
              @for (item of yesNoOptions; track item) {
                <ng-template [coinValue]="item">{{ 'gbr.person-input.' + item | translate }}</ng-template>
              }
            </coin-v2-dropdown>
            <coin-v2-dropdown
              required
              matFormFieldClass="shadow"
              [label]="'gbr.person-input.in-education' | translate"
              [(ngModel)]="$any(formPerson).inEducation">
              @for (item of yesNoOptions; track item) {
                <ng-template [coinValue]="item">{{ 'gbr.person-input.' + item | translate }}</ng-template>
              }
            </coin-v2-dropdown>
          </div>
        }
      </div>
    }
  </coin-v2-card>
</div>
